import { Component, OnInit } from '@angular/core';
import { GetTaskListService } from '../../services/get-task-list.service';
import { Subscription} from 'rxjs';
import { first } from 'rxjs/operators'
import { CreateObjectDialog } from './create-object-dialog';
import { MatDialog } from '@angular/material/dialog';
import { MediaMatcher } from '@angular/cdk/layout';
import { GeaMesCognitoAuthService } from '@gea-mes/cognito';
import { ManualLoadDialog } from './manual-load-dialog';
import { AssetListStorageService } from '../../services/asset-list-storage.service';
import { ScheduleDataService } from '../../services/schedule-data.service';
import { environment } from 'src/environments/environment';
import dayjs from 'dayjs'
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ObjectNode } from 'src/app/services/object-list.service';
dayjs().format()
import { LogDialogComponent } from '../log-dialog/log-dialog.component';
import { NgFor, NgIf, DatePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatToolbar } from '@angular/material/toolbar';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatIcon } from '@angular/material/icon';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatCardFooter, MatCardActions } from '@angular/material/card';
 
export interface task {
  task: string;
}


@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    imports: [NgFor, MatButton, RouterLink, NgIf, MatToolbar, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIcon, FileUploadComponent, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatCardFooter, MatCardActions, DatePipe]
})
export class AdminComponent implements OnInit {
  
  displayedObjectColumns: string[] = ['objectID','section','subsection','description','updatestatus','formrev','eamasset','actions']
  dataSource: any;
  selectedSite: string;
  selectedEnv: string;
  selectedObject: string;
  selectedStatus: string;
  selectedFormnum: string;
  selectedRevision:string;
  selOriginalFileName:string;
  fullSizeMatcher: MediaQueryList;
  adminFlag: boolean;
  assetList: any[];
  productionMode: boolean;
  scheduleDataStatus: string;

  subscription: Subscription;
  adminSub$: Subscription;
  eamServiceSubscription: Subscription;

  mDataSource: {};
  objectList: any[] = [];

  sectionKeys = Object.keys;
 
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private AdminService: GetTaskListService,
    public dialog: MatDialog,
    public mediaMatcher: MediaMatcher,
    private geaMesCognito: GeaMesCognitoAuthService,
    private assetListStorage: AssetListStorageService,
    private scheduleData: ScheduleDataService
  ) { 
    this.selectedSite = ''
    this.selectedObject = ''
    
    // Check to see if this user is an admin
    this.adminSub$ = this.geaMesCognito.isUserInRole("Admin").pipe(first()).subscribe( out => { 
      this.adminFlag = out;
      if (this.adminSub$) this.adminSub$.unsubscribe(); // We've got an answer, can unsubscribe now
    });
  }

  ngOnInit() {
    if (environment.production) this.productionMode = true;

    if (this.route.snapshot.paramMap.has('plant')) {
      this.selectSite(this.route.snapshot.paramMap.get('plant'));
    } else {
      this.getSiteObjectList();
    }
    this.fullSizeMatcher = this.mediaMatcher.matchMedia('(min-width: 1024px)');
  }

  getSiteObjectList() {
    if (this.subscription) this.subscription.unsubscribe();     

    this.subscription = this.AdminService.objectList().subscribe(
      (out) => {
        let objectList:ObjectNode[] = out.Body;

        this.mDataSource = [...new Set(objectList.map(item => item.SiteDescription))]; // Unique list of plants
  
        if (this.selectedSite != "") {
          let plantObjects:ObjectNode[] = objectList.filter(x => x.SiteDescription === this.selectedSite);

          this.objectList = [];
          plantObjects.forEach(
            (object) => {
              this.objectList.push(this.buildObject(object.Section, object.SubSection, object));
            }
          )
        } else {
          this.unsubscribe(); // If not listing objects, no need to constantly refresh
        }
      }
    )
  }

  buildObject(sectionDesc:string, subSectionDesc:string, obj):{} {
    let object = {};
    object["site"] = obj["Site"];
    object["environment"] = obj["Environment"];
    object["section"] = sectionDesc;
    object["subsection"] = subSectionDesc
    object["lineID"] = obj["LineID"]
    object["subLineID"] = obj["SubLineID"]
    object["objectID"] = obj["ObjectID"];
    object["description"] = obj["ObjectDescription"];
    object["updatestatus"] = obj["UpdateStatus"];
    object["EAMAsset"] = obj["EAMAsset"];
    object["LastFileUpdateTime"] = obj["LastFileUpdateTime"];
    object["OriginalFileName"] = obj["OriginalFileName"];
    object["form_number"] = obj["form_number"];
    object["revision"] = obj["revision"];
    object["loadtime"] = obj["LoadTime"];
    object["ManualLoad"] = obj["ManualLoad"];
    object["RequireComment"] = obj["RequireComment"];
    object["RequireWorkRequest"] = obj["RequireWorkRequest"];
    object["DefaultEAMAsset"] = obj["DefaultEAMAsset"]

  /*  object["LastFileUpdateTime"] = dayjs(object["LastFileUpdateTime"]).format('YYYY-MM-DD HH:mm:ss')  */
    if (object["LastFileUpdateTime"] == 'Invalid Date')
      object["LastFileUpdateTime"] = "";
    return object;
  }
  
  selectSite(site: string) {
    console.log(site)
    this.selectedSite = site;
    this.getSiteObjectList();

    let sitePre = site.split(' ')[0]
    this.assetListStorage.updateAssetList(sitePre)
  }

  deleteObject(displayName: string, objectid: string) {
    if (confirm("Are you sure to delete "+objectid)) {
      this.AdminService.deleteObject(displayName, objectid).subscribe((
        out => {
            console.log(out);
            this.getSiteObjectList();
      }));    
    }
  }

  navigateTaskList(site: string, environment: string, object: string): void {
    this.router.navigate(["/admin/tasklist",this.selectedSite, site, environment, object]);
  }

  editObject(isEdit: boolean, displayName?: string, lineID?:number, subLineID?:number, object?: string, section?: string, subsection?:string, description?: string, eamasset?: string, loadtime?: number, manualLoad?: number, requirecomment?: number, requireworkrequest?: number, defaulteamasset?: number) {
    console.log("requirecomment", requirecomment);
    let data = {};
    if (displayName != undefined) {
      data = {
        "isEdit": isEdit,
        "display_name": displayName,
        "section": section,
        "subsection": subsection,
        "lineID": lineID,
        "subLineID": subLineID,
        "objectid": object,
        "manualDescription": description,
        "eam_asset": eamasset,
        "loadtime":loadtime,
        "manualLoad": manualLoad,
        "requirecomment": requirecomment,
        "requireworkrequest": requireworkrequest,
        "defaulteamasset": defaulteamasset
      }
    } else{
      data = {
        "isEdit": isEdit
      }
    }
    console.log("OPEN DIALOG!!",data);

    const dialogRef = this.dialog.open(CreateObjectDialog, {
      width: '800px',
      maxHeight: '825px',
      data: {objData: data, objs: this.objectList}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      let site = result
      this.getSiteObjectList();
      if(site) this.selectSite(site);
    });

  }

  manualUpload(site: string, environment: string, objectid: string) {
    console.log(site, environment, objectid)

    const dialogRef = this.dialog.open(ManualLoadDialog, {
      width: '500px',
      maxHeight: '500px',
      data: {
        "site": site,
        "objEnv": environment,
        "objID": objectid
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("AFTER CLOSED!");
    });

  }

  selectScheduleData(){
    console.log ("selectScheduleData")
    this.scheduleDataStatus = ""
    this.scheduleData.buildScheduleData().subscribe((response) =>{
      console.log(response['Body']['errorMessage'])
      if (response['Body']['errorMessage'] != "")
        this.scheduleDataStatus = 'There was an error creating Schedule Data'
      else
        this.scheduleDataStatus = 'Schedule Data has been created'
    })
  }

  objectLog(site:string, environemnt: string, objectID: string){
    console.log(site,environemnt,objectID)
    this.dialog.open(LogDialogComponent, {
      width: '1000px',
      data: 
      { 
        site: site,
        proficy_env: environemnt,
        object_id: objectID
      }
    });
  }

  unsubscribe() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.adminSub$) this.adminSub$.unsubscribe();
  }  


}
